export interface CountryCatalogEntry {
  name: string;
  alpha2_code: string;
  alpha3_code: string;
  numeric_code: string;
}

export interface CountryOption {
  label: string;
  value: string;
  disabledReason?: string;
}

const TRAILING_ARTICLE = '(the)';

export const normalizeCountryName = (countryName: string) => {
  const trimmedName = countryName.trimEnd();
  const suffixStart = trimmedName.length - TRAILING_ARTICLE.length;
  const hasSeparatedTrailingArticle =
    suffixStart > 0 && trimmedName.toLocaleLowerCase().endsWith(TRAILING_ARTICLE) && trimmedName.charAt(suffixStart - 1).trim() === '';

  return hasSeparatedTrailingArticle ? trimmedName.slice(0, suffixStart).trimEnd() : countryName;
};

export const createCountryOptions = (countries: CountryCatalogEntry[]): CountryOption[] =>
  countries
    .map(country => ({
      label: normalizeCountryName(country.name),
      value: country.alpha2_code.toUpperCase(),
    }))
    .sort((first, second) => first.label.localeCompare(second.label));
